export const ROLE_START = 'role/role-start';
export const ROLE_SUCCESS = 'role/role-success';
